export const formatClientDisplayId = (accountSupportId?: string | null): string => {
  const value = accountSupportId?.trim();
  return value || '—';
};
